module.exports = __webpack_public_path__ + "static/media/bz.6a62bd9a.svg";